import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TimerService {

  public minutes=0;
  public seconds=0;
  public interval;
  constructor() {
  
  }

  getMinutes(){
    return this.minutes;
  }
  getSeconds(){
    return this.seconds;
  }

  start(){
    return this.interval =  setInterval(()=>{
      this.seconds++;
      if(this.seconds==60){
        this.minutes++;
        this.seconds=0;
      }
    },1000);
  }

  pause(){
    clearInterval(this.interval);
  }

  stop(){
    clearInterval(this.interval);
    this.minutes=0;
    this.seconds=0;
  }
}

